"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var ButtonComponent_1 = __importDefault(require("../FormComponents/ButtonComponent"));
var react_cropper_1 = __importDefault(require("react-cropper"));
var styles_1 = require("@mui/styles");
var messageTypes_1 = require("../../types/messageTypes");
var crudeActions = __importStar(require("../../../store/crude/crude.actions"));
var react_redux_1 = require("react-redux");
require("cropperjs/dist/cropper.css");
var ImageCropperComponent = function (props) {
    var t = react_i18next_1.useTranslation().t;
    var dispatch = react_redux_1.useDispatch();
    var _a = react_1.useState(props.image), image = _a[0], setImage = _a[1];
    var _b = react_1.useState(), cropper = _b[0], setCropper = _b[1];
    var useStyles = styles_1.makeStyles(function (theme) { return ({
        imageCropper: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
        },
    }); });
    var classes = useStyles();
    react_1.useEffect(function () {
        props.image && setImage(props.image);
    }, [props.image]);
    var fileSize = function (imageBaseString) {
        var suffix = 1; // y will be 2 if Base64 ends with '==' and 1 if Base64 ends with '='.
        var imageSize = imageBaseString.length;
        var size = (imageSize * (3 / 4)) - suffix;
        return size;
    };
    var getCropData = function () {
        var cropData = cropper.getCroppedCanvas().toDataURL();
        var fileSizeCalc = fileSize(cropData);
        if (!props.maximumFileSize || (fileSizeCalc / 1024 / 1024) < props.maximumFileSize) {
            props.changeImage(cropData);
        }
        else {
            var message = {
                eventType: messageTypes_1.EventType.upload,
                severity: messageTypes_1.Severity.error,
                message: t('crude:errorLargeFileUpload'),
            };
            dispatch(crudeActions.addMessage(message));
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: classes.imageCropper },
            react_1.default.createElement(react_cropper_1.default, { style: { width: '100%', overflow: 'hidden', margin: '20px 0' }, preview: "." + props.previewContainer, src: image, viewMode: 1, guides: true, minCropBoxHeight: 10, minCropBoxWidth: 10, scalable: true, zoomable: true, background: true, responsive: true, aspectRatio: props.imageRatio, autoCropArea: 1, checkOrientation: false, onInitialized: function (instance) {
                    setCropper(instance);
                } }),
            react_1.default.createElement(ButtonComponent_1.default, { styles: { margin: '10px 0' }, color: 'primary', text: t('crude:useCroppedImage'), onClick: getCropData }),
            react_1.default.createElement(ButtonComponent_1.default, { styles: { margin: '10px 0' }, color: 'primary', text: t('crude:useOriginalImage'), onClick: function () { return props.useOrigin && props.useOrigin(); } }))));
};
exports.default = ImageCropperComponent;
